import React from 'react';

interface GstToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  taxRate?: number;
  className?: string;
  id?: string;
}

export const GstToggle: React.FC<GstToggleProps> = ({
  enabled,
  onChange,
  taxRate = 18,
  className = '',
  id = 'gst-toggle-button',
}) => {
  return (
    <div
      onClick={() => onChange(!enabled)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onChange(!enabled);
        }
      }}
      className={`
        group relative flex items-center gap-3 px-3.5 py-2 rounded-xl border cursor-pointer select-none transition-all duration-200
        ${
          enabled
            ? 'bg-gradient-to-r from-teal/10 via-teal/5 to-transparent border-teal shadow-sm ring-1 ring-teal/20'
            : 'bg-white border-gray-200 hover:border-gray-300 hover:bg-gray-50/50 shadow-sm'
        }
        ${className}
      `}
      id={id}
    >
      <div className="flex flex-col text-left">
        <div className="flex items-center gap-2">
          <span
            className={`text-xs sm:text-sm font-semibold transition-colors ${enabled ? 'text-teal font-bold' : 'text-gray-800'}`}
          >
            Show Inclusive GST
          </span>
        </div>
        <span className="text-[11px] text-gray-400 font-normal">
          {enabled
            ? 'Rates include 18% service tax'
            : 'Rates exclude service tax'}
        </span>
      </div>

      {/* Modern Switch */}
      <div
        className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out ${
          enabled ? 'bg-teal' : 'bg-gray-300'
        }`}
      >
        <span
          className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-md ring-0 transition duration-200 ease-in-out ${
            enabled ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </div>
    </div>
  );
};

export default GstToggle;
